<section class='hero is-primary is-fullheight'>
    <div class='hero-body'>
        <div class='container has-text-centered'>
            <img src='logo192.png' alt=""/>
            <h1 class='title appfont'>
                {$displayName}
            </h1>
            <progress class='progress is-small' max='100'></progress>
            <div>{$progressMessage}</div>
        </div>
    </div>
</section>

<style>
    .progress {
        width: 15em;
        margin: auto;
    }
</style>
